import { useEffect,useState } from "react";

export function isMobile() {
 
    const [ width, setWidth ] = useState( window.innerWidth ) // valor inicial da largura da tela
  
    function handleWindowSizeChange ()
    {
      setWidth( window.innerWidth ) // valor da tela no momento
    }
  
    useEffect( () =>
    {
      window.addEventListener( 'resize', handleWindowSizeChange )
      return () => { window.removeEventListener( 'resize', handleWindowSizeChange ) }
    }, [] );
  
    return width <= 768 // retornar a resposta era 768
  
  }